import React from "react";

import { useNavigate } from "react-router-dom";
import defaultuser from "../assets/images/defaultuser.jpg";
import { DeleteIcon } from "@/constants/utils/svgs";
import { Languages } from "@/constants/Common";
import StarRating from "./StarRating/StarRating";
import deleteIcon from '../assets/icons/deleteIcon.svg'
import { formatNumber } from "@thdinc/hpf-shared";

const BartenderCard = (props: any) => {
  // const [optionVisible, setOptionVisible] = useState(false)
  const navigate = useNavigate();

  const handleInnerDivClick = (
    e: React.MouseEvent<HTMLDivElement, MouseEvent>
  ) => {
    // Prevent the click event from bubbling up to the parent div
    e.stopPropagation();
    props.setModal(true);
    props.setActiveId(props?.item?.id);
  };
  return (
    <div
      onClick={() => {
        navigate("/bartenders/schedule", { state: { id: props?.item?.id } });
      }}
      className="w-full   mx-auto  cursor-pointer relative   bg-white  p-5  flex justify-start gap-4 items-start  rounded-xl"
      key={props?.index}
    >
        <img
          alt={defaultuser}
          src={
            props.item?.avatar?.includes("https://")
              ? props?.item?.avatar
              : defaultuser
          }
          className="   border-2  object-cover  sm:h-[103px] sm:w-[103px] w-24 h-24 rounded-full   self-center"
        />
      {/* Adjust px and py for padding as per your requirement */}
      {/* <div className="h-7  mx-4 rounded-t-md bg-orange-600 opacity-45">

      </div> */}
      <div className="">
        {!props?.item?.is_admin && (
          <div className="absolute right-2 ">
            <div data-testid="delete-icon " className="p-2 bg-p-gray rounded-full font-bold" onClick={handleInnerDivClick}>
              <img src={deleteIcon}  />
            </div>
          </div>
        )}
        {/* <div onClick={() => { setOptionVisible(!optionVisible) }} className="justify-end flex" >
                        <img src={more} className=" h-4 w-auto mr-3" />
                        {
                            optionVisible &&
                            <div className="bg-white absolute shadow-md -mr-28 mt-6 px-4 py-4  w-32 rounded-md" >
                                <p className="text-sm" >Edit</p>
                                <p className="text-sm my-1 py-1 border-y-2 border-black">Delete</p>
                                <p className="text-sm">Schedule</p>
                            </div>
                        }
                    </div> */}



        {/* Your item content */}
        <div className="  overflow-hidden">
          <h1 className="text-36 font-nunito font-semibold text-black md:text  text-wrap text-start ">
            {(props?.item?.first_name + props?.item?.last_name).length > 15
              ? (props?.item?.first_name + "\n" + props?.item?.last_name).slice(
                0,
                10
              ) + "..."
              : props?.item?.first_name + "\n" + props?.item?.last_name}
          </h1>
          {/* <div className="flex gap-1 justify-start">
            {props.item.languages.map((lang: string, index: number) => {
              return (
                <p className="text-xs text-gray-600" key={index}>
                  {Languages[lang]}
                </p>
              );
            })}

            
          </div> */}
          <div className="text-gray-500 text-sm">
            ${formatNumber(props.item.bartender_price/100)}/h
          </div>
          <p className="text-xs text-primary-red font-semibold mt-2">{props?.item?.guests_per_bartender} Guests</p>
          <div className="justify-center flex mt-2 " >
                    <StarRating rating={5} index={props?.index} />
                </div>
          {/* <p className="text-20 font-nunito text-black text-center my-1">${props?.item?.hourly_rate ?? 0}/h</p> */}
          {/* <p className="text-20 font-nunito  text-black text-center my-1">{props?.item?.guest_capacity ?? 0} guests</p> */}
        </div>
      </div>
    </div>
  );
};

export default BartenderCard;
